<template>
  <div class="not__found"></div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style lang="scss" scoped>
.not__found {
  background-image: url("../assets/NOT_FOUND404.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  height: 40rem;
}
</style>
